import { API_URLS } from "../config/api";
import L from "leaflet";

/**
 * Get polygon filter for Overpass API query
 */
export function getPolygonFilter(layer) {
  if (layer instanceof L.Circle) {
    const center = layer.getLatLng();
    const radius = layer.getRadius();
    return `around:${radius},${center.lat},${center.lng}`;
  } else {
    const latlngs = layer.getLatLngs()[0];
    return 'poly:"' + latlngs.map((p) => `${p.lat} ${p.lng}`).join(" ") + '"';
  }
}

/**
 * Fetch OSM data from Overpass API
 */
export async function fetchOSMData(polyFilter) {
  const query = `
    [out:json][timeout:30];
    (
      way[building](${polyFilter});
      relation[building](${polyFilter});
      way[natural="wood"](${polyFilter});
      relation[natural="wood"](${polyFilter});
      way[leisure="park"](${polyFilter});
      relation[leisure="park"](${polyFilter});
      way[natural="water"](${polyFilter});
      relation[natural="water"](${polyFilter});
      way["landuse"="residential"](${polyFilter});
      relation["landuse"="residential"](${polyFilter});
      way["landuse"="commercial"](${polyFilter});
      relation["landuse"="commercial"](${polyFilter});
      way["landuse"="industrial"](${polyFilter});
      relation["landuse"="industrial"](${polyFilter});
    );
    out geom;
  `;

  const response = await fetch(API_URLS.OVERPASS, {
    method: "POST",
    body: query,
  });

  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }

  return await response.json();
}
